import { NgModule } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CommonModule } from '@angular/common';
import { SanitizePipe } from './sanitize.pipe';
import { VersionComponent } from './version/version.component';
import { ModalComponent } from './modal/modal.component';
import { StoreModule } from '@ngrx/store';
import { cityReducers } from './cities/city.reducer';
import { countryReducers } from './countries/country.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CityEffects } from './cities/city.effects';
import { CountryEffects } from './countries/country.effects';
import { ByArtistPipe } from './by-artist.pipe';
import { InUseModalComponent } from './in-use-modal/in-use-modal.component';
import { AnimatedDotsComponent } from './animated-dots/animated-dots.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    SanitizePipe,
    VersionComponent,
    ModalComponent,
    ByArtistPipe,
    InUseModalComponent,
    AnimatedDotsComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature('cities', cityReducers),
    StoreModule.forFeature('countries', countryReducers),
    EffectsModule.forFeature([CityEffects, CountryEffects]),
  ],
  exports: [
    BreadcrumbComponent,
    SanitizePipe,
    CommonModule,
    VersionComponent,
    ModalComponent,
    ByArtistPipe,
    InUseModalComponent,
    AnimatedDotsComponent,
  ],
})
export class SharedModule {}
